
import Clarity from '@microsoft/clarity';
import { useState } from "react";
import { Helmet } from "react-helmet";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CLARITY_PROJECT_ID } from '../../../project_config';
import { LoginHelper } from "../../../utils/LoginHelper";
import Breadcrumb from "../../common/breadcrumb/Breadcrumb";
import Footer from "../../common/footer/Footer";
import { FooterButton } from "../../common/footer/FooterButton";
import Header from "../../common/header/Header";
import CatalogExpertiseFilterSection from "../../common/expertise/CatalogExpertiseFilterSection";
import CreateSection from "./create/CreateSection";
import MyWebinarSection from "./my_webinar/MyWebinarSection";
import SearchSection from "./search/SearchSection";
import WebinarSection from "./webinar/WebinarSection";

function webinarListPath(query, expertiseId) {
	const params = new URLSearchParams();
	if (query) {
		params.set("query", query);
	}
	if (expertiseId) {
		params.set("expertise_id", expertiseId);
	}
	const qs = params.toString();
	return qs ? `/webinar_list/?${qs}` : "/webinar_list/";
}

export default function WebinarList() {
	Clarity.init(CLARITY_PROJECT_ID);
	const navigate = useNavigate();
	const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);
	const linkDataList = [
		{ label: 'خانه', href: '/' },
		{ label: 'وبینارها', href: '/webinar_list/' },
	];
	const [searchParams] = useSearchParams();
	const queryParam = searchParams.get("query");
	const expertiseIdParam = searchParams.get("expertise_id");

	function onExpertiseClick(newExpertiseId) {
		if (String(newExpertiseId) !== String(expertiseIdParam)) {
			navigate(webinarListPath(queryParam, newExpertiseId || ""));
		} else {
			navigate(webinarListPath(queryParam, ""));
		}
	}

	function onSearch(newQuery) {
		if (newQuery === queryParam) {
			return;
		}
		navigate(webinarListPath(newQuery || "", expertiseIdParam || ""));
	}

	return (
		<>
			<Helmet>
				<title>وبینارها | همراهتیم</title>
				<meta name="description" content="فهرست وبینارهای همراهتیم" />
			</Helmet>

			<div className="bg-[#F0F6FC] flex min-h-screen flex-col">
				<div className="flex flex-1 flex-col">
					<Header isDesktop={isDesktop} />
					<div className="bg-white">
						<div className={`${isDesktop ? 'w-[1200px]' : ''} mx-auto`}>
							<Breadcrumb linkDataList={linkDataList} />
						</div>
					</div>
					<div
						className={`${isDesktop ? "w-[1200px]" : "px-[10px]"} mx-auto flex flex-1 flex-col gap-5 pt-6 md:pt-8 pb-4`}
					>
						{LoginHelper.isLoggedIn() && LoginHelper.getProfileMode() === LoginHelper.MODE_TYPE_DOCTOR && (
							<CreateSection isDesktop={isDesktop} />
						)}
						{LoginHelper.isLoggedIn() && LoginHelper.getProfileMode() === LoginHelper.MODE_TYPE_DOCTOR && (
							<MyWebinarSection isDesktop={isDesktop} />
						)}
						<SearchSection initQuery={queryParam} onSearch={onSearch} />
						<CatalogExpertiseFilterSection
							isDesktop={isDesktop}
							selectedExpertiseId={expertiseIdParam}
							onExpertiseClick={onExpertiseClick}
						/>
						<WebinarSection
							isDesktop={isDesktop}
							query={queryParam}
							expertiseId={expertiseIdParam}
						/>
					</div>
				</div>
				<Footer isDesktop={isDesktop} activeButton={FooterButton.WEBINARS} />
			</div>
		</>
	)
}
